/**
 * Yvine Design — blog page (topic filter).
 * Cached asset, initialised once per [data-art="blog"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 *
 * Topics are the posts' tags, listed in the shared side rail
 * (snippets/art-rail.liquid; the phone sheet opens and closes in art-rail.js).
 * Each row is a real link (?t=topic); here a click filters the posts already
 * on the page instead, with the page-change fade (Art.fade).
 */
Art.section('blog', function (root) {
  var list = root.querySelector('[data-rail-list]');
  var grid = root.querySelector('[data-blog-grid]');
  var noResults = root.querySelector('[data-blog-noresults]');
  var current = root.querySelector('[data-blog-current]');
  if (!list || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-article-tags]'));
  var items = Array.prototype.slice.call(list.querySelectorAll('a.art-rail__item'));

  function tagOf(a) {
    var m = (a.getAttribute('href') || '').match(/[?&]t=([^&#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function tagFromUrl() {
    var m = window.location.search.match(/[?&]t=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // The rail row lights at once, so the click feels heard before the fade.
  function mark(tag) {
    var label = '';
    items.forEach(function (a) {
      var on = tagOf(a) === tag;
      a.classList.toggle('is-active', on);
      if (on) {
        a.setAttribute('aria-current', 'page');
        var name = a.querySelector('.art-rail__name');
        label = name ? name.textContent.trim() : '';
      } else {
        a.removeAttribute('aria-current');
      }
    });
    if (current) current.textContent = label || current.getAttribute('data-all-label') || '';
  }

  function matches(tag) {
    return function (card) {
      if (!tag) return true;
      return (card.getAttribute('data-article-tags') || '').split(/\s+/).indexOf(tag) !== -1;
    };
  }

  function settle(tag) {
    if (noResults) noResults.hidden = cards.some(matches(tag));
  }

  // Straight to a state, no motion (a shared link on first load).
  function apply(tag) {
    var m = matches(tag);
    cards.forEach(function (card) { card.hidden = !m(card); });
    settle(tag);
  }

  // Post by post: the ones that no longer match fade away, the rest glide
  // together, newly matching ones fade in (Art.filterItems, art-core.js).
  function choose(tag, push) {
    mark(tag);
    if (push) {
      var url = tag ? (window.location.pathname + '?t=' + encodeURIComponent(tag)) : window.location.pathname;
      history.pushState({ artBlogTag: tag || '' }, '', url);
    }
    if (noResults && !cards.some(matches(tag))) noResults.hidden = true; // shown once the others have gone
    if (window.Art && Art.filterItems) Art.filterItems(cards, matches(tag), { container: root.querySelector('[data-blog-results]'), done: function () { settle(tag); } });
    else apply(tag);
  }

  // Before art-transitions.js sees the link: filter in place, no page load.
  list.addEventListener('click', function (e) {
    var a = e.target.closest('a.art-rail__item');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    choose(tagOf(a), true);
  });

  // On window, so it outlives its own markup: it retires once the blog list
  // it filters has been swapped out.
  window.addEventListener('popstate', function onPop() {
    if (!document.contains(root)) { window.removeEventListener('popstate', onPop); return; }
    choose(tagFromUrl(), false);
  });

  // A topic in the URL on first load (a shared link): straight there, no fade.
  var initial = tagFromUrl();
  if (initial) { mark(initial); apply(initial); }
});
